.fullHeight {
  height: 100%;
  min-height: 300px;
}